import React, { useState } from "react";
import { Collapse } from "reactstrap";
import { Filter, FilterGroup } from "../../api";
import { ChevronDown, ChevronRight } from "react-feather";

export interface FilterPanelProps {
  items: FilterGroup[];
  values: string[];
  onChange?: (name: string, value: string, checked: boolean) => any;
}

const FilterPanel: React.FC<FilterPanelProps> = ({ items, values, onChange }) => {

  const [openGroups, setOpenGroups] = useState<string[]>([]);

  const toggleGroup = (groupTitle: string): void => {
    const isClose = openGroups.includes(groupTitle);
    setOpenGroups(titles =>
      isClose
        ? titles.filter(x => x !== groupTitle)
        : [...titles, groupTitle]);
  }

  const handleFilterChange = (name: string, value: string, checked: boolean) => {
    if (typeof onChange === "function") {
      onChange(name, value, checked);
    }
  }

  const getCount = (items: Filter[]) => {
    return items.filter(item => values.includes(item.value)).length;
  }

  return (
    <>
      {items.map(group => {
        const count = getCount(group.filters);
        return (
          <div key={group.title}>
            <a href="#0"
              className="d-flex align-items-center justify-content-between text-decoration-none"
              onClick={(e) => {
                e.preventDefault();
                toggleGroup(group.title);
              }}>
              <div className="d-flex align-items-center">
                <div>
                  {openGroups.includes(group.title)
                    ? <ChevronDown />
                    : <ChevronRight />
                  }
                </div>
                <div className="h6 mb-0">
                  {group.title}
                </div>
              </div>
              <div>
                {count !== 0 &&
                  <span className="badge badge-pill badge-primary">{count}</span>
                }
              </div>
            </a>
            <Collapse
              isOpen={openGroups.includes(group.title)}>
              <div className="mt-2">
                {group.filters.map(filter => {
                  return (
                    <label
                      key={`${filter.name}-${filter.value}`}
                      className="d-flex justify-content-between mx-1">
                      <span>{filter.label}</span>
                      <span>
                        <input
                          type="checkbox"
                          checked={values.includes(filter.value)}
                          onChange={(e) => handleFilterChange(filter.name, filter.value, e.target.checked)} />
                      </span>
                    </label>
                  )
                })}
              </div>
            </Collapse>
          </div>
        )
      })}
    </>
  );
};

export default FilterPanel;
